<template>
	<div>

		<div class="container">
			<div class="row justify-content-center">
				<div class="col-xl-8 header">
					<h3 class="index-title">{{steps.title}}</h3>
					<div class="tag"></div>
					<span class="index-desc"
						style="margin-top: 8px;">{{steps.desc}}</span>
				</div>
			</div>

			<div class="row justify-content-center">
				<div class="col-xl-8">
					<div class="steps">
						<template v-for="(step, index) in steps.list">
							<div v-if="index > 0" :key="'line' + index" class="line"></div>
							<div :key="index" class="icon" :style="{
				backgroundColor: index === currentIndex ? '#FF2E48' : 'white',
				color: index === currentIndex ? '#FF2E48' : '#3B3A40'
			}" @click="currentIndex = index">
								<el-image :src="index === currentIndex ? step.icon2 : step.icon" fit="cover">
								</el-image>

								<span class="text">{{step.text}}</span>
							</div>
						</template>
					</div>
				</div>
			</div>
			
			<div class="row justify-content-center">
				<div class="col-xl-8 step">
					
				<!-- 	<div class="bg">
						<el-image :src="bg" fit="cover" class="img">
						</el-image>
					</div> -->
					<!-- <el-image :src="steps[currentIndex].fg" fit="contain" class="fg" lazy="true">
					</el-image> -->
					<img :src="steps.list[currentIndex].fg"  class="fg" alt=""/>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		props: {
			steps: Object
		},
		data() {
			return {
				currentIndex: 0,
				bg: require('@/assets/images/provider/bg.png'),
				
			}
		}
	}
</script>

<style scoped lang="scss">


	.header {
		text-align: center;
		margin-top: 80px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.tag {
			width: 56px;
			height: 7px;
			background: #168FFE;
			border-radius: 4px;
		}

		.desc {
			margin-top: 4px;
			color: #666666;
		}


	}

	.steps {
		margin-top: 40px;
		margin-bottom: 40px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.line {
			flex-grow: 1;
			height: 1px;
			background: #E8E7E8;
		}

		.icon {
			flex-shrink: 0;
			position: relative;
			width: 60px;
			height: 60px;
			border-radius: 30px;
			background: #FFFFFF;
			box-shadow: 0px 8px 26px 0px rgba(59, 58, 64, 0.08);
			border: 1px solid #E8E7E8;
			display: flex;
			justify-content: center;
			align-items: center;

			.text {
				position: absolute;
				bottom: -30px;
				left: -40px;
				right: -40px;
				font-size: 12px;
				text-align: center;
			}
		}
	}


	.step {
		position: relative;
		
		.bg {
			text-align: center;
			position: absolute;
			width: 100vw;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			z-index: 0;
			overflow-x: visible;
			// overflow-y: hidden;
			.img {
				// width: 1024px;
				height:1000px;
				text-align: center;
				background-color: red;
			}
		}
		.fg {
			position: relative;
			padding: 10%;
			
		}
	}
</style>
